package com.wintermar.inspection.feature.presentation.template.widget.preview

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.lazy.LazyListScope
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import com.wintermar.inspection.core.ui.component.TextBodyLarge
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.component.datetime.util.DateTimeUtil
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import com.wintermar.inspection.core.ui.util.modifier.card
import com.wintermar.inspection.feature.presentation.template.landing.TemplateLandingState
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.last_updated
import inspection.composeapp.generated.resources.pages
import inspection.composeapp.generated.resources.total_pages_and_question
import org.jetbrains.compose.resources.stringResource

actual fun LazyListScope.itemHeaderContent(
    state: TemplateLandingState,
    topPadding: Dp,
    defaultPadding: Dp,
    color: ThemeColor
) {
    item {
        Spacer(modifier = Modifier.height(topPadding))
        TextBodyLarge(text = state.detailTemplate.name, bold = true)
        Spacer(modifier = Modifier.height(defaultPadding))
        Column(
            modifier = Modifier.card(),
            verticalArrangement = Arrangement.spacedBy(defaultPadding)
        ) {
            ContentItem(
                label = stringResource(Res.string.pages),
                value = stringResource(
                    Res.string.total_pages_and_question,
                    state.detailTemplate.pages.size,
                    state.detailTemplate.numberOfQuestions
                )
            )

            ContentItem(
                label = stringResource(Res.string.last_updated),
                value = DateTimeUtil.getLocalSystemDisplayWithTime(state.detailTemplate.publishedDate)
            )
        }
        Spacer(modifier = Modifier.height(defaultPadding))
    }
}

@Composable
private fun ContentItem(
    label: String,
    value: String
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.SpaceBetween
    ) {
        TextBodySmall(text = label, color = { it.subtle })
        TextBodySmall(text = value)
    }
}
